import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import {
  EnrichmentListResult,
  GetEnrichmentListParams
} from "../../recommendation.types";

export const requestGetEnrichmentList = async (
  params: GetEnrichmentListParams
): Promise<EnrichmentListResult> => {
  return await instance.get(ApiRoutesRecommendation.Enrichment, { params });
};
